import React from 'react'
import loadingImg from "./../../assets/images/loading-spinner.gif"
import "./Loading.scss"
const Loading = () => {
    return (
        <div className="loading-container">
            <img src={loadingImg} alt="loading..." />
        </div>
    )
}

export default Loading
